import React from "react";
import { useState } from "react";
import "../styles/Manufacturing.css";

function FAQItem({ question, answer }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="faq-item">
      <button className="faq-question" onClick={() => setOpen(!open)}>
        {question}
        <span className={`arrow ${open ? "open" : ""}`}>▼</span>
      </button>

      {open && <p className="faq-answer">{answer}</p>}
      <hr />
    </div>
  );
}

function Manufacturing() {
  return (
    <div className="background">
      <div className="container">
        <div className="manufacturing-intro">
          <h1>Full Steam Ahead</h1>
          <p className="basic-text">
            Move your products quickly and keep orders flowing without getting
            held up by long waits for customer payments.
          </p>
        </div>

        <div className="manufacturing-fast">
          <div className="h2-styling">
            <h2>Move As Fast As Your Inventory</h2>
          </div>
          <p className="basic-text">
            Keep pace with customer demand by closing the gap between when
            orders go out and when payments come in. With support from Trana,
            your manufacturing business can sidestep delays caused by
            slow‑moving invoices. Get paid quickly, cover essential expenses,
            and stay agile as customer needs shift.
          </p>
        </div>

        <div className="manufacturing-alleviate">
          <div className="alleviate-text">
            <div className="h3-styling">
              <h3>Alleviate Cost Pressure and Meet Changing Demands</h3>
            </div>

            <p className="basic-text">
              Getting your products shipped and into customers’ hands often
              means waiting weeks or even months before payments arrive. During
              that time, your business has already invested significant time,
              labor, and resources into production. That gap can strain
              operations and slow growth. For manufacturers, invoice‑based
              support offers a practical way to ease cash flow challenges and
              keep the business moving forward.
            </p>
          </div>

          <div className="alleviate-image">
            <img src="/alleviate.jpg" alt="alleviate" />
          </div>
        </div>

        <div className="manufacturing-flexibility">
          <div className="h3-styling">
            <h3>Get Flexibility to Move Products and Make Decisions</h3>
          </div>

          <div className="flexibility-row">
            <div className="flexibility-image">
              <img src="/flexibility.jpg" alt="flexibility" />
            </div>

            <div className="flexibility-text">
              <p className="basic-text">
                When your invoices are paid the same day they’re issued, you can
                immediately restock materials, pay your team, and keep
                production running at full speed. Connect with a Trana Client
                Relationship Manager to learn how invoice‑based support can help
                elevate your manufacturing operations.
              </p>
            </div>
          </div>
        </div>

        {/* ------------------ FAQ SECTION ------------------ */}
        <div className="manufacturing-faq">
          <h2>FAQs About Manufacturing Invoice Factoring</h2>
          <FAQItem
            question="What is manufacturing factoring?"
            answer={
              <>
                Manufacturing factoring is a process where you sell your open
                invoices so you can get paid right away instead of waiting 30 to
                90 days. By transferring your active receivables to a factoring
                partner, you turn those unpaid invoices into usable funds that
                help you cover day‑to‑day operating needs.
                <br />
                <br />
                This creates steady cash flow, keeps production moving, and
                helps ease pressure caused by slow‑paying customers.
              </>
            }
          />

          <FAQItem
            question="What are the benefits of manufacturing factoring?"
            answer="Using invoice support in the manufacturing space can help protect you from customer non‑payment, make it easier for clients to place larger orders, and give you the ability to pay sub‑contractors and suppliers earlier."
          />

          <FAQItem
            question="What percentage do factoring companies take?"
            answer="Most manufacturing‑focused factoring providers charge fees in the range of 1% to 3% of the invoice amount. Rates vary depending on the company and the level of service included, so it’s important to choose a reliable partner that offers a fair and transparent structure."
          />
        </div>
      </div>
    </div>
  );
}

export default Manufacturing;
